'use client';

import React, { useState } from 'react';
import { Box, Flex, Heading, Text, Button } from '@chakra-ui/react';
import TopRankedCategoryFilter from './components/TopRankedCategoryFilter';
import TopRankedProductGrid from './components/TopRankedProductGrid';
import LucideIcon from '@/components/ui/LucideIcon';
import TopRankedProductGridSkeleton from './components/TopRankedProductGridSkeleton';
import { ProductCategory } from '@/constants/product/category';
import SectionContainer from '@/components/shared/SectionContainer';
import { SafeLink } from '@/components/ui/SafeLink';
import QueryBoundary from '@/components/ui/QueryBoundary';
import { format } from 'date-fns';

const TopRankedSection = () => {
  const [selectedCategory, setSelectedCategory] = useState<ProductCategory>(ProductCategory.ESSENCE_SERUM);
  const currentMonth = format(new Date(), 'MMMM');

  const handleCategoryChange = (category: ProductCategory) => {
    setSelectedCategory(category);
  };

  return (
    <SectionContainer
      containerInnerProps={{
        background: 'linear-gradient(180deg, #3A1589 0%, #0F0523 218.45%)',
        paddingY: { base: 12, tablet: 12, desktop: 12 },
      }}
    >
      <Flex direction="column" width="100%" gap={12}>
        <Flex direction="column" width="100%" gap={2}>
          <SafeLink href="/shop/?orderby=date" width="100%" _hover={{ textDecoration: 'none' }}>
            <Flex
              alignItems="center"
              width="100%"
              justify={{ base: 'space-between', tablet: 'start' }}
              gap={{ base: 3, tablet: 4 }}
            >
              <Heading as="h2" color="common.100" fontWeight="regular" textStyle="heading2">
                Top Ranked In {currentMonth}
              </Heading>
              <LucideIcon name="ChevronRight" boxSize={6} color="common.100" />
            </Flex>
          </SafeLink>

          <Text color="neutral.10" textStyle="body2" fontWeight="regular">
            Based solely on thousands of reviews & ratings from Korea
          </Text>
        </Flex>

        <Box
          width="100%"
          overflowX="auto"
          css={{ scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' } }}
        >
          <TopRankedCategoryFilter selectedCategory={selectedCategory} onCategoryChange={handleCategoryChange} />
        </Box>
        <QueryBoundary loadingFallback={<TopRankedProductGridSkeleton />}>
          <TopRankedProductGrid selectedCategory={selectedCategory} />
        </QueryBoundary>

        <Flex justifyContent="center" width="100%" marginTop={{ base: 4, tablet: 6 }}>
          <SafeLink href="/shop/?orderby=date" width={{ base: 'full', tablet: '332px' }}>
            <Button
              backgroundColor="transparent"
              border="1px solid"
              borderColor="common.100"
              borderRadius="4px"
              color="common.100"
              textStyle="body3"
              fontWeight="regular"
              height="48px"
              padding={4}
              width={{ base: 'full', tablet: '332px' }}
              _hover={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              }}
            >
              View all
            </Button>
          </SafeLink>
        </Flex>
      </Flex>
    </SectionContainer>
  );
};

export default TopRankedSection;
